﻿window.cBuilderEmailWidgetCtrlSelect = function cBuilderEmailWidgetCtrlSelect(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformselect"
    this.icone = "fas fa-list";
    this.nomBt = "Liste";
    this.titleBt = "Zone de sélection<br/>liste de choix<br/>liste de tag<br/>liste de case à cocher"
    this.labelCtrl = "Choisissez une valeur"
    this.typeDevExpress = "dxSelect"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();
        $Td.attr("typeCtrlDevexpress", "dxSelectBoxClose")
        $Td.attr("datasource", "[]")

        Me.mAddCtrlDevExpress()
    };

    var _onValueChangedDevexpress = null
    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        _onValueChangedDevexpress = onValueChangedDevexpress
        Me.mGetTdSaisie().empty()

        var ds = JSON.parse(Me.mGetTdSaisie().attr("datasource"))

        switch (Me.mGetTdSaisie().attr("typeCtrlDevexpress")) {
            case "dxList": case "dxRadioGroup":
                if (ds.length > 0) {
                    var $DivTitle = $("<div style='color:initial;text-align:initial;font-size:14px;opacity:0.4;'/>").appendTo(Me.mGetTdSaisie())
                    $DivTitle.text((Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"))
                    $DivTitle.css("font-family", "'Helvetica Neue','Segoe UI',helvetica,verdana,sans-serif")
                }
                break;
        }

        var ctrl = null
        var $DivVide = $("<div style='display:none;'/>").appendTo(Me.mGetTdSaisie())
        var $Div = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + " " + (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "obligatoire" : "") + "'/>").appendTo(Me.mGetTdSaisie())
        switch (Me.mGetTdSaisie().attr("typeCtrlDevexpress")) {
            case "dxSelectBoxOpen": case "dxSelectBoxClose":
                var opt = {
                    items: ds,
                    noDataText: "Aucune valeur",
                    stylingMode: "outlined", //pour voir la bordure,
                    label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
                    labelMode: "floating",
                    dropDownOptions: {
                        container: Me.mGetTdSaisie(),
                        onShowing: function (e) {
                            e.component.$content().css("text-align", "left");
                        }
                    },
                    onValueChanged: function (e) {
                        ctrl.element().css("background-color", "")
                        ctrl.element().closest("td").css("border-left", "")
                        onValueChanged([e.component.option("value")])
                    }
                }
                if (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxSelectBoxOpen") {
                    opt.searchEnabled = true
                    opt.acceptCustomValue = true
                }
                ctrl = $Div.dxSelectBox(opt).dxSelectBox("instance");
                ctrl.isEmpty = function () { return ctrl.option("value") == null || ctrl.option("value").length==0 }
                break;
            case "dxTagBoxOpen": case "dxTagBoxClose":
                var opt = {
                    items: ds,
                    noDataText: "Aucune valeur",
                    stylingMode: "outlined", //pour voir la bordure,
                    label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
                    labelMode: "floating",
                    searchEnabled: true,
                    dropDownOptions: {
                        container: Me.mGetTdSaisie(),
                        onShowing: function (e) {
                            e.component.$content().css("text-align", "left");
                        }
                    },
                    onValueChanged: function (e) {
                        ctrl.element().css("background-color", "")
                        ctrl.element().closest("td").css("border-left", "")
                        onValueChanged(e.component.option("value"))
                    }
                }
                if (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxTagBoxOpen") {
                    opt.acceptCustomValue = true
                    opt.onCustomItemCreating = function (args) {
                        const newValue = args.text;
                        const { component } = args;
                        const currentItems = component.option('items');
                        const isItemInDataSource = currentItems.some((item) => item === newValue);
                        if (!isItemInDataSource) {
                            currentItems.unshift(newValue);
                            component.option('items', currentItems);
                        }
                        args.customItem = newValue;
                    }
                }
                ctrl = $Div.dxTagBox(opt).dxTagBox("instance");
                ctrl.isEmpty = function () { return ctrl.option("value") == null || ctrl.option("value").length == 0 }
                break;
            case "dxList":
                $Div.css("text-align", "left")
                ctrl = $Div.dxList({
                    items: ds,
                    noDataText: "Aucune valeur",
                    stylingMode: "outlined", //pour voir la bordure,
                    label: Me.mGetTdSaisie().attr("label"),
                    labelMode: "floating",
                    //height: 400,
                    showSelectionControls: true,
                    selectionMode: 'all',
                    selectByClick: true,
                    pageLoadMode: 'scrollBottom',
                    onSelectionChanged(e) {
                        ctrl.element().css("background-color", "")
                        ctrl.element().closest("td").css("border-left", "")
                        onValueChanged(e.component.option("selectedItems"))
                    },
                    onContentReady: function (e) {
                        e.element.find('.dx-list-select-all').hide();
                    }
                }).dxList('instance');
                ctrl.isEmpty = function () { return ctrl.option("selectedItems") == null || ctrl.option("selectedItems").length == 0 }
                if (ds.length == 0) {
                    $Div.hide()
                    $DivVide.show()
                    $DivVide.dxTextBox({
                        value: "aucune valeur",
                        stylingMode: "outlined", //pour voir la bordure,
                        label: Me.mGetTdSaisie().attr("label"),
                        labelMode: "floating",
                        readOnly: true,
                        disabled: true
                    })
                }
                break;
            case "dxRadioGroup":
                ctrl = $Div.dxRadioGroup({
                    items: ds,
                    noDataText: "Aucune valeur",
                    stylingMode: "outlined", //pour voir la bordure,
                    label: Me.mGetTdSaisie().attr("label"),
                    labelMode: "floating",
                    layout: 'horizontal',
                    onValueChanged: function (e) {
                        ctrl.element().css("background-color", "")
                        ctrl.element().closest("td").css("border-left", "")
                        onValueChanged([e.component.option("value")])
                    }
                }).dxRadioGroup("instance");
                ctrl.isEmpty = function () { return ctrl.option("value") == null || ctrl.option("value").length == 0 }
                if (ds.length == 0) {
                    $Div.hide()
                    $DivVide.show()
                    $DivVide.dxTextBox({
                        value: "aucune valeur",
                        stylingMode: "outlined", //pour voir la bordure,
                        label: Me.mGetTdSaisie().attr("label"),
                        labelMode: "floating",
                        readOnly: true,
                        disabled: true
                    })
                }
                break;
        }
        return ctrl

        function onValueChanged(lstValue) {
            if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), Me.mGetTdSaisie().attr("typeCtrlDevexpress"), Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), lstValue)
        }
    }

    this.mGetTypeCtrlDevexpress = function (value) {
        return (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxSelectBoxOpen" ? "dxSelectBox" :
            (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxSelectBoxClose" ? "dxSelectBox" :
                (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxTagBoxOpen" ? "dxTagBox" :
                    (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxTagBoxClose" ? "dxTagBox" :
                        (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxList" ? "dxList" :
                            (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxRadioGroup" ? "dxRadioGroup" : null))))))
    };


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Type de sélection:</div>").appendTo(contentElement)
        var dsTypeCtrl = ["Sélection ouverte", "Sélection fermé", "Liste tag ouvert", "Liste tag fermé", "liste case à cocher", "liste de choix"]
        $("<div/>").appendTo(contentElement).dxRadioGroup({
            items: dsTypeCtrl,
            value: (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxSelectBoxOpen" ? dsTypeCtrl[0] :
                (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxSelectBoxClose" ? dsTypeCtrl[1] :
                    (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxTagBoxOpen" ? dsTypeCtrl[2] :
                        (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxTagBoxClose" ? dsTypeCtrl[3] :
                            (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxList" ? dsTypeCtrl[4] :
                                (Me.mGetTdSaisie().attr("typeCtrlDevexpress") == "dxRadioGroup" ? dsTypeCtrl[5] : null)))))),
            layout: 'horizontal',
            onValueChanged: function (e) {
                Me.mGetTdSaisie().attr("typeCtrlDevexpress",
                    (e.value == dsTypeCtrl[0] ? "dxSelectBoxOpen" :
                        (e.value == dsTypeCtrl[1] ? "dxSelectBoxClose" :
                            (e.value == dsTypeCtrl[2] ? "dxTagBoxOpen" :
                                (e.value == dsTypeCtrl[3] ? "dxTagBoxClose" :
                                    (e.value == dsTypeCtrl[4] ? "dxList" :
                                        (e.value == dsTypeCtrl[5] ? "dxRadioGroup" : ""))))))
                );
                Me.mAddCtrlDevExpress(_onValueChangedDevexpress)
                option.onValueChanged()
            }
        }).dxRadioGroup("instance");

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Liste de valeurs:</div>").appendTo(contentElement)
        var ds = JSON.parse(Me.mGetTdSaisie().attr("datasource"))
        Me.dx.option("maxLength", ds)
        $("<div/>").appendTo(contentElement).dxTagBox({
            label: "Saisissez les différentes valeur pour la liste de choix",
            labelMode: "floating",
            dataSource: ds,
            value: ds,
            noDataText: "Aucune valeur",
            searchEnabled: true,
            acceptCustomValue: true,
            onCustomItemCreating: function (e) {
                e.customItem = e.text;
            },
            onValueChanged: function (e) {
                Me.mGetTdSaisie().attr("datasource", JSON.stringify(e.value))
                Me.dx.option("items", e.value)
                Me.mAddCtrlDevExpress(_onValueChangedDevexpress)
                option.onValueChanged()
                //console.log(e.value);
                //// ["toto", "titi", "tata"]
            }
        });
    };
};